import React from 'react';

import { Modal, Avatar } from 'antd';

import fetch from './../fetch';
import utils from './../../utils';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.count ? <span>{d.label}
                <Avatar size="small" className='dtme-target' style={{ backgroundColor: '#87d068', marginLeft: 10, verticalAlign: 'middle', textAlign: 'center' }}>{d.count}</Avatar>
            </span> : d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
// const querySearchByOrgId = (targetId, orgId) => {
//     return fetch.get(`dtme/target/getSub/${targetId}/${orgId}`, {})
//         .then(response => response.payload.data)
//         .then(result => {
//             const data = transform(utils.tree(result));
//             const maps = codes(result);
//             return {
//                 data,
//                 maps
//             }
//         })
//         .catch(error => {
//             // console.log('error');
//         });
// }
const querySearchByOrgId = (targetId, orgId, evaluationType) => {
    return fetch.post(`dtme/target/getSubDetail`, {
        targetId: targetId,
        orgId: orgId,
        evaluationType: evaluationType
    })
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps,
                result
            }
        })
        .catch(error => {
            // console.log('error');
        });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = () => {
    return fetch.get('dtme/target/tree', {})
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}

const insert = (domain) => {
    return fetch.post(`dtme/target/insert`, domain)
}

const get = (id) => {
    return fetch.get(`dtme/target/get/${id}`)
}

const update = (id, domain) => {
    return fetch.post(`dtme/target/update/${id}`, domain)
}

const remove = (id) => {
    return fetch.post(`dtme/target/remove/${id}`, {})
}

export default {
    querySearch,
    insert,
    get,
    update,
    remove,
    querySearchByOrgId
}